import { render, staticRenderFns } from "./BitcoinFountainDescription.vue?vue&type=template&id=132191c6&scoped=true&"
import script from "./BitcoinFountainDescription.vue?vue&type=script&lang=js&"
export * from "./BitcoinFountainDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132191c6",
  null
  
)

export default component.exports